import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { AddBeneficiary as BENE_ADD } from 'Components/Api/CasaDMTAPI';
import { SelectBank as BANK_SELECT } from 'Components/Api/CasaDMTAPI';
import { MoneyTransfer as DMT_TRANSFER } from 'Components/Api/CasaDMTAPI';
import { ViewBeneficiary as BENE_SELECT } from 'Components/Api/CasaDMTAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import { Container, Grid, Paper, Button, Hidden } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
import { KeyValueModal } from 'Components/Modal/KeyValueModal';
import { CheckBranch as CHECK_BRANCH } from 'Components/Api/BeneficiaryAPI';
import AutoSubmitIFSCForBeneAdd from 'Components/Helper/AutoSubmitIFSCForBeneAdd';
import IFSCThroughBankAddress from 'Components/IFSCThroughBankAddress';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import { textAlign } from '@material-ui/system';
const CustomContainer = HOCLoader(Container);

export const BeneficiaryAdd = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [isBeneVerifyOpen, setIsBeneVerifyOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [verifyStatus, setVerifyStatus] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [bankList, setBankList] = useState([]);
    const [list, setList] = useState([]);
    const [isAddOnly, setIsAddOnly] = useState(false);
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [BeneVerifyDetails, setBeneVerifyDetails] = useState([]);
    const [IFSCAddress, setIFSCAddress] = useState('');
    const [Branch, setBranch] = useState('');
    const [bankDefault, setBankDefault] = useState({
        Name: 'Select Bank',
        DefaultIFSC: '',
        BankID: 0
    });
    const location = useLocation();
    const Mobile = location?.state?.Mobile;
    const SenderName = location?.state?.SenderName;
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        Bank: bankDefault,
        AccountNo: '',
        ConfirmAccountNo: '',
        IFSC: '',
        SenderID: '',
    });

    useEffect(() => {
        selectBank();
        selectBene();
        select();
        createColumns();
    }, []);

    const reset = () => {
        setBankDefault({
            Name: 'Select Bank',
            DefaultIFSC: ''
        });
        setFormObject({
            Mobile: Mobile,

            Name: '',
            Bank: bankDefault,
            AccountNo: '',
            ConfirmAccountNo: '',
            IFSC: '',
            isAddOnly: false,
            IsNameVerified: false,  
        });
    };

    const select = () => {
        setLoading(false);
        setFormObject((prevFormObject) => ({
            ...prevFormObject,
            Mobile: Mobile,
        }));
    };
    const selectBank = async () => {
        setLoading(true);
        const response = await BANK_SELECT();
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };

    const selectBene = async () => {
        setLoading(true);
        setIsError(false);
        let senderNo = Mobile;
        if (senderNo === undefined) return;

        if (senderNo === '') return;

        var beneReqObj = JSON.stringify({
            Mobile: Mobile,
        });

        var response = await BENE_SELECT(beneReqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);
        setList(data);
    };

    const core_bene_add = async (values, beneName) => {
        setResponseMessage('');
        var request = {
            Name: beneName,
            BankName: values.Bank.Name,
            BankID: values.Bank.BankID,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            SenderMobile: values.Mobile,
            SenderID: values.Mobile,
        };

        var requestObj = JSON.stringify(request);
        setLoading(true);
        setIsError(false);

        var response = await BENE_ADD(requestObj);
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);

            return;
        }

        setSeverity('success');
        setResponseMessage(response.data);
        var param = {
            Mobile: values.Mobile,
            SelectedBank: values.Bank.Name
        };
        await selectBene();
        await selectBank();
        history.push('/CS_SenderSearch', param);
    };

    const createKeyValuePair = (data) => {
        if (data.Status === 'FAILURE') {
            let rows = [
                VerifyData('Name', data.BeneficiaryName),
                VerifyData('Bank', data.BankName),
                VerifyData('IFSC', data.IFSC),
                VerifyData('Account', data.ConsumerNumber),
                VerifyData('Message', data.Description)
            ];
            setBeneVerifyDetails(rows);
        } else {
            let rows = [
                VerifyData('Name', data.BeneficiaryName),
                VerifyData('Bank', data.BankName),
                VerifyData('IFSC', data.IFSC),
                VerifyData('Account', data.ConsumerNumber)
            ];
            setBeneVerifyDetails(rows);
        }
    };

    function VerifyData(Key, Value) {
        return { Key, Value };
    }

    const GetBranch = async (values, setFieldValue) => {
        var request = {
            IFSC: values.IFSC
        };
        var requestObj = JSON.stringify(request);

        setLoading(true);

        setIsError(false);

        var response = await CHECK_BRANCH(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setLoading(false);

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);

            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);

        setBankDefault({
            DefaultIFSC: data.IFSC,
            Name: data.BankName
        });

        setFieldValue('Bank.Name', data.BankName);

        setBranch(data.Branch);
        setIFSCAddress(data.Address);
    };

    const submithandle = async (
        values,
        { setSubmitting, resetForm, setFieldValue }
    ) => {
        if (loading) {
            setLoading(false);
            return;
        }
        setResponseMessage('');
        if (values.isAddOnly === true) {
            setIsAddOnly(true);
            core_bene_add(values, values.Name);
            return;
        }

        let jsonObj = {
            BeneficiaryID: values.Mobile,
            Name: 'Testing',
            SenderName: SenderName,
            BankName: values.Bank.Name,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            SenderID: values.Mobile,
            Mobile: values.Mobile,
            PaymentType: 'IMPS',
            Through: 'WEB',
            IsVerify: true,
            Amount: 1,
            RechargePin: '',
            BankID: values.Bank.BankID
        };
        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(apirequest);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            return;
        }

        setSeverity('success');
        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setIsError(true);
        setVerifyStatus(data.Status);
        createKeyValuePair(data);
        setIsBeneVerifyOpen(true);
        setFieldValue('Name', data.BeneficiaryName);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });
        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });
        columns.push({
            label: 'AccountNo',
            name: 'AccountNo'
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });

        setMainColumns(columns);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile'),

        isAddOnly: Yup.boolean(),
        Name: Yup.string().when(['isAddOnly'], {
            is: (isAddOnly) => isAddOnly,
            then: Yup.string().required(PLEASE_PROVIDE_VALID + 'name')
        }),

        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        ConfirmAccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'confirm account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no')
            .oneOf([Yup.ref('AccountNo'), null], "AccountNo don't match"),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <AutoSubmitIFSCForBeneAdd
                                        callback={() => {
                                            GetBranch(values, setFieldValue);
                                        }}
                                    />
                                    <Paper className={classes.PaperStyle}>
                                        <Grid container spacing={2}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <Field
                                                    component={
                                                        AutoCompleteTextView
                                                    }
                                                    defaultValue={bankDefault}
                                                    SubFieldName="Name"
                                                    FieldName="Bank"
                                                    name="Bank"
                                                    onCustomCallback={(
                                                        name,
                                                        value
                                                    ) => {
                                                        setFieldValue(
                                                            'IFSC',
                                                            value.DefaultIFSC
                                                        );

                                                        setBankDefault({
                                                            Name: value.Name,
                                                            DefaultIFSC:
                                                                value.DefaultIFSC,
                                                            BankID: value.BankID
                                                        });
                                                    }}
                                                    options={bankList}
                                                    getOptionLabel={(option) =>
                                                        option.Name
                                                    }
                                                    getOptionSelected={(
                                                        option,
                                                        value
                                                    ) =>
                                                        option.Name ===
                                                        value.Name
                                                    }
                                                    textFieldProps={{
                                                        label: 'Bank'
                                                    }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={9}
                                                lg={9}
                                            >
                                                <MaterialTextField
                                                    label="IFSC"
                                                    name="IFSC"
                                                    type="text"
                                                    length={11}
                                                    placeholder="IFSC"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                lg={3}
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    title="Check Branch"
                                                    endIcon={<SearchIcon />}
                                                    onClick={() => {
                                                        GetBranch(
                                                            values,
                                                            setFieldValue
                                                        );
                                                    }}
                                                    disabled={loading}
                                                ></Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <IFSCThroughBankAddress
                                                    Branch={Branch}
                                                    IFSCAddress={IFSCAddress}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialNumberField
                                                    label="Account No."
                                                    name="AccountNo"
                                                    type="password"
                                                    length={20}
                                                    placeholder="Account No."
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialNumberField
                                                    label="Confirm Account No."
                                                    name="ConfirmAccountNo"
                                                    type="text"
                                                    length={20}
                                                    placeholder="Confirm Account No."
                                                />
                                            </Grid>

                                            {/* <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                lg={3}
                                            >
                                                <div
                                                    className={
                                                        classes.SubmitWrapper
                                                    }
                                                >
                                                    <Button
                                                        type="submit"
                                                        title="Verify"
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'isAddOnly',
                                                                false
                                                            );
                                                            handleSubmit(e);
                                                        }}
                                                        disabled={loading}
                                                    >
                                                        Verify
                                                    </Button>
                                                    {loading && (
                                                        <CircularProgress
                                                            size={24}
                                                            className={
                                                                classes.buttonProgress
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            </Grid> */}
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialTextField
                                                    label="Bene Name"
                                                    name="Name"
                                                    type="text"
                                                    placeholder="FirstName LastName"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialTextField
                                                    label="Mobile"
                                                    name="Mobile"
                                                    type="text"
                                                    length={10}
                                                    //readOnly={true}
                                                    placeholder="Mobile"
                                                />

                                                <Hidden xsUp>
                                                    <MaterialTextField
                                                        label="SenderID"
                                                        name="SenderID"
                                                        type="text"
                                                        readOnly={true}
                                                        placeholder="SenderID"
                                                    />
                                                </Hidden>
                                            </Grid>
                                        </Grid>
                                    </Paper>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                                style={{
                                                    display: 'flex',
                                                    gap: '30px'
                                                }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    style={{
                                                        backgroundColor:
                                                            '#D5006D',
                                                        color: 'white',
                                                        width: '80px'
                                                    }}
                                                    onClick={() => {
                                                        history.push(
                                                            '/CS_SenderSearch',
                                                            {
                                                                Mobile: Mobile,
                                                            }
                                                        );
                                                    }}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddOnly',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>

                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                                onClick={() => {
                                                    reset();
                                                }}
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="lastrecharges"
                            >
                                <h2 className={classes.PaperHead_h2}>
                                    Beneficiary List
                                </h2>
                                <ReactTable data={list} columns={mainColumns} />
                            </Grid>
                        </Grid>
                    );
                }}
            />

            {isBeneVerifyOpen ? (
                <KeyValueModal
                    isOpen={isBeneVerifyOpen}
                    request={BeneVerifyDetails}
                    title="VERIFY"
                    status={verifyStatus}
                    OKButtonClick={() => {
                        setIsBeneVerifyOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
